/* eslint-disable no-console */
// Aviso de "hay una nueva versión disponible", independiente del service worker.
//
// Por qué no basta con el service worker:
// El aviso original colgaba de register-service-worker (evento `updated`), que el
// navegador sólo dispara cuando el /service-worker.js descargado difiere BYTE A
// BYTE del instalado. Con workbox 4 ese archivo es prácticamente
// `importScripts("/precache-manifest.<md5>.js")` + la config, así que su
// contenido sólo cambia si cambia el precache-manifest.
//
// Desde que se dejaron fuera del precache el index.html y todo el js/css
// hasheado (ver las notas de `exclude` en vue.config.js), el manifest sólo
// contiene archivos estáticos de public/ que no cambian entre despliegues -> el
// service-worker.js queda idéntico build tras build -> el navegador nunca
// detecta actualización -> `updated` no se dispara y el aviso dejó de aparecer.
//
// Solución: comparar el BUILD_ID compilado dentro de este bundle contra el
// /version.json publicado. Es la fuente de verdad correcta porque BUILD_ID
// describe el código que el usuario está ejecutando REALMENTE, no lo que el
// navegador acaba de descargar (una pestaña con index.html cacheado también
// queda cubierta).
//
// El aviso del service worker se mantiene: cuando sí se dispara es una señal
// válida, y ambos caminos emiten el mismo evento `appUpdateAvailable`.

// Inyectado por DefinePlugin desde vue.config.js.
const BUILD_ID = process.env.VUE_APP_BUILD_ID || null

const VERSION_URL = `${process.env.BASE_URL || '/'}version.json`

// Mismo intervalo que el chequeo del service worker: una pestaña abierta por
// horas se entera de un despliegue sin depender de que el usuario recargue.
const CHECK_INTERVAL = 5 * 60 * 1000

let started = false

// Una vez detectada la versión nueva seguimos notificando en cada chequeo, para
// que el aviso reaparezca si el usuario lo cerró (mismo criterio que el SW).
let updatePending = false

const notifyUpdateAvailable = () => {
    window.dispatchEvent(new CustomEvent('appUpdateAvailable'))
}

async function fetchPublishedBuildId () {
    // `cache: 'no-store'` + query única: version.json es el único archivo que NO
    // puede servirse desde ninguna cache, ni del navegador ni de Cloudflare.
    const response = await fetch(`${VERSION_URL}?t=${Date.now()}`, {
        cache: 'no-store',
        credentials: 'omit'
    })

    if (!response.ok) return null

    // Si version.json no existe, Cloudflare Pages responde el fallback de la SPA:
    // index.html con HTTP 200 y content-type text/html. Sin esta guarda
    // intentaríamos parsearlo como JSON en cada chequeo.
    const contentType = response.headers.get('content-type') || ''
    if (!contentType.includes('application/json')) return null

    const data = await response.json()

    return data && data.buildId ? String(data.buildId) : null
}

export async function checkForNewVersion () {
    if (updatePending) {
        notifyUpdateAvailable()

        return
    }

    try {
        const publishedBuildId = await fetchPublishedBuildId()

        if (publishedBuildId && publishedBuildId !== BUILD_ID) {
            updatePending = true
            notifyUpdateAvailable()
        }
    } catch (error) {
        // Red caída o despliegue a medias: se reintenta en el próximo ciclo. No
        // es un error que valga la pena reportar a Sentry (mismo criterio que
        // registration.update() en registerServiceWorker.js).
    }
}

export function startVersionCheck () {
    if (started || !BUILD_ID) return
    started = true

    // Chequeo inmediato: cubre el caso de una pestaña que arrancó desde un
    // index.html cacheado y por lo tanto ya nació desactualizada.
    checkForNewVersion()

    setInterval(checkForNewVersion, CHECK_INTERVAL)

    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') checkForNewVersion()
    })
}
